import { Container, makeStyles, Paper } from "@material-ui/core";

import { Cooperation } from "../../gardener/gardener.model";
import { LevelIconAndText } from "../your-level/LevelIconAndText";
import { determineNextCooperationLevel, determineNumberOfTasksBenefit, determinePriorityBenefit } from "../utility";
import { UnorderedList } from "../../components/unordered-list/UnorderedList";
import { BlockingProgressItemHeader } from "./BlockingProgressHeader";

const useStyles = makeStyles(theme => ({
    card: {
        overflow: "hidden",
        padding: "24px",

        "& > *": {
            marginBottom: "24px",

            "&:last-child": {
                marginBottom: 0,
            },
        },
    },
    paragraph: {
        fontSize: "16px",
        fontWeight: 400,
        color: "#4A4A4A",

        "& > span": {
            fontWeight: 600,
        },

        [theme.breakpoints.down(500)]: {
            textAlign: "center",
        },
    },
}));

type LevelUpItemProps = {
    cooperationLevel: Exclude<Cooperation["level"], "bronze" | "platin">;
    tasksUntilNextLevel: number;
    onClose?: () => void;
} | {
    cooperationLevel: "platin";
    tasksUntilNextLevel: null;
    onClose?: () => void;
}

export const LevelUpItem = (props: LevelUpItemProps) => {
    const classes = useStyles();
    const { cooperationLevel, tasksUntilNextLevel, onClose } = props;

    const numberOfTasksBenefit = determineNumberOfTasksBenefit(cooperationLevel);
    const priorityBenefit = determinePriorityBenefit(cooperationLevel);

    return (
        <Container maxWidth="sm" disableGutters>
            <Paper className={classes.card}>

                <BlockingProgressItemHeader onClose={onClose}>
                    Dit niveau er nu <LevelIconAndText cooperationLevel={cooperationLevel} />
                </BlockingProgressItemHeader>

                {cooperationLevel !== "platin" ? (
                    <div className={classes.paragraph}>
                        Tillykke! Du gør det godt og er derfor steget i niveau 🥳
                    </div>
                ) : (
                    <div className={classes.paragraph}>
                        Tillykke! Du har nået det højeste niveau – virkelig flot arbejde! 👏
                    </div>
                )}

                <div className={classes.paragraph}>
                    Dine nye fordele:
                    <UnorderedList>
                        <li>{numberOfTasksBenefit}</li>
                        <li>{priorityBenefit}</li>
                    </UnorderedList>
                </div>

                {(() => {
                    if ( cooperationLevel !== "platin" ) {
                        const nextCooperationLevel = determineNextCooperationLevel(cooperationLevel);

                        return (
                            <div className={classes.paragraph}>
                                Løs <span>{tasksUntilNextLevel} {tasksUntilNextLevel !== 1 ? "opgaver" : "opgave"}</span> for
                                at nå <LevelIconAndText cooperationLevel={nextCooperationLevel} />
                            </div>
                        )
                    } else {
                        return <div>Fortsæt den gode indsats! 💪</div>;
                    }
                })()}

            </Paper>
        </Container>
    );
};
